module.exports = __webpack_public_path__ + "static/media/orderTypes.b58f67be.svg";